import { getValue, getValues, getProperties } from './cssVariablesGetter';
import { updateCss } from './updateCss';
import { load } from './load';
import { updateDensity } from './density';
import { DIRECTIVE_DENSITY, WATCH_DIRECTIVE, ID_SKIN, ID_DENSITY } from './constants';

const isWatch = document.documentElement.hasAttribute(WATCH_DIRECTIVE);

function setNewDensity(newValue) {
  const oldValue = document.documentElement.getAttribute(DIRECTIVE_DENSITY);
  if (newValue === oldValue) {
    return;
  }

  document.documentElement.setAttribute(DIRECTIVE_DENSITY, newValue);
  if (isWatch) {
    return;
  }
  updateDensity();
}
/**
 * create api
 */

export const themeApi = {
  density: {
    set: (css = '') => {
      document.documentElement.setAttribute(DIRECTIVE_DENSITY, 'custom');
      !isWatch && updateCss(css, ID_DENSITY);
    },
    load: (url = '') => {
      document.documentElement.setAttribute(DIRECTIVE_DENSITY, url);
      !isWatch && updateDensity();
    },
    setDefault: () => {
      setNewDensity('default');
    },
    setCompact: () => {
      setNewDensity('compact');
    },
    setComfortable: () => {
      setNewDensity('comfortable');
    },
  },

  skin: {
    set: (css = '') => {
      return updateCss(css, ID_SKIN);
    },
    load: (url = '') => {
      return load(url, ID_SKIN);
    },
  },

  /**
   * css properties
   */
  getValue,
  getValues,
  getProperties,
};
